// import { createContext, useContext, useEffect, useState } from 'react';
// import { fetchCollection } from './fetchUtils'; // Firestore fetching function

// const CollectionContext = createContext();

// export const CollectionProvider = ({ collectionName, collectionNames, children }) => {
//   const [data, setData] = useState(() => {
//     // Check if a single collection is provided
//     if (collectionName) {
//       const storedData = localStorage.getItem(collectionName);
//       return storedData ? JSON.parse(storedData) : null;
//     }
    
//     // Check for multiple collections
//     if (collectionNames) {
//       const storedDataArray = collectionNames.map(name => {
//         const item = localStorage.getItem(name);
//         return item ? JSON.parse(item) : null;
//       });
//       return storedDataArray.some(item => item !== null) ? storedDataArray : null;
//     }

//     return null;
//   });

//   const [isLoading, setIsLoading] = useState(!data);

//   useEffect(() => {
//     if (!data) {
//       let fetchedData = [];
//       let unsubscribeFunctions = [];

//       if (collectionName) {
//         // Fetch single collection
//         const unsubscribe = fetchCollection(collectionName, (items) => {
//           if (items.length > 0) {
//             setData(items[0]);
//             localStorage.setItem(collectionName, JSON.stringify(items[0]));
//           }
//           setIsLoading(false);
//         });

//         return () => unsubscribe(); // Cleanup on unmount
//       }

//       if (collectionNames) {
//         // Fetch multiple collections
//         collectionNames.forEach((name, index) => {
//           const unsubscribe = fetchCollection(name, (items) => {
//             if (items.length > 0) {
//               fetchedData[index] = items[0];
//               localStorage.setItem(name, JSON.stringify(items[0]));
//             }

//             if (fetchedData.length === collectionNames.length) {
//               setData(fetchedData);
//               setIsLoading(false);
//             }
//           });

//           unsubscribeFunctions.push(unsubscribe);
//         });

//         return () => unsubscribeFunctions.forEach(unsub => unsub()); // Cleanup listeners
//       }
//     }
//   }, [data, collectionName, collectionNames]);

//   return (
//     <CollectionContext.Provider value={{ data, isLoading }}>
//       {children}
//     </CollectionContext.Provider>
//   );
// };

// // Custom hook for easy access
// export const useCollection = () => {
//   return useContext(CollectionContext);
// };
import { createContext, useContext, useEffect, useState } from 'react';
import { fetchCollection } from './fetchUtils'; // Firestore fetching function

const CollectionContext = createContext();

export const CollectionProvider = ({ collectionName, collectionNames, children }) => {
  const [data, setData] = useState(() => {
    if (collectionName) {
      const storedData = localStorage.getItem(collectionName);
      return storedData ? JSON.parse(storedData) : null;
    }

    if (collectionNames) {
      const storedDataArray = collectionNames.map(name => {
        const item = localStorage.getItem(name);
        return item ? JSON.parse(item) : null;
      });
      return storedDataArray.some(item => item !== null) ? storedDataArray : null;
    }

    return null;
  });

  const [isLoading, setIsLoading] = useState(!data);

  useEffect(() => {
    let unsubscribeFunctions = [];

    const updateLocalStorage = (key, items) => {
      if (items.length > 0) {
        localStorage.setItem(key, JSON.stringify(items[0]));
        setData(prevData => {
          if (Array.isArray(prevData)) {
            return prevData.map((item, index) =>
              collectionNames[index] === key ? items[0] : item
            );
          }
          return items[0];
        });
      }
    };

    if (collectionName) {
      const unsubscribe = fetchCollection(collectionName, (items) => {
        updateLocalStorage(collectionName, items);
        setIsLoading(false);
      });
      unsubscribeFunctions.push(unsubscribe);
    }

    if (collectionNames) {
      let fetchedData = [];

      collectionNames.forEach((name, index) => {
        const unsubscribe = fetchCollection(name, (items) => {
          updateLocalStorage(name, items);
          fetchedData[index] = items[0];

          if (fetchedData.length === collectionNames.length) {
            setData(fetchedData);
            setIsLoading(false);
          }
        });

        unsubscribeFunctions.push(unsubscribe);
      });
    }

    return () => unsubscribeFunctions.forEach(unsub => unsub());
  }, [collectionName, collectionNames]);

  return (
    <CollectionContext.Provider value={{ data, isLoading }}>
      {children}
    </CollectionContext.Provider>
  );
};

// Custom hook for easy access
export const useCollection = () => {
  return useContext(CollectionContext);
};




// import { createContext, useContext, useEffect, useState } from 'react';
// import { fetchCollection } from './fetchUtils'; // Firestore fetching function

// const CollectionContext = createContext();

// export const CollectionProvider = ({ collectionName, collectionNames, children }) => {
//   const [data, setData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     let unsubscribeFunctions = [];

//     const fetchData = () => {
//       if (collectionName) {
//         // Check if data exists in localStorage
//         const cachedData = localStorage.getItem(collectionName);
//         if (cachedData) {
//           setData(JSON.parse(cachedData)); // Use cached data immediately
//           setIsLoading(false);
//         }

//         // Set up real-time listener for Firestore updates
//         const unsubscribe = fetchCollection(collectionName, (items) => {
//           if (items.length > 0) {
//             const newData = items[0];
//             setData(newData); // Update state with fresh data
//             localStorage.setItem(collectionName, JSON.stringify(newData)); // Cache fresh data
//           }
//           setIsLoading(false);
//         });

//         unsubscribeFunctions.push(unsubscribe);
//       }

//       if (collectionNames) {
//         // Handle multiple collections (similar logic as above)
//         collectionNames.forEach((name, index) => {
//           const cachedData = localStorage.getItem(name);
//           if (cachedData) {
//             setData((prevData) => {
//               const newData = [...(prevData || [])];
//               newData[index] = JSON.parse(cachedData);
//               return newData;
//             });
//             setIsLoading(false);
//           }

//           const unsubscribe = fetchCollection(name, (items) => {
//             if (items.length > 0) {
//               const newData = items[0];
//               setData((prevData) => {
//                 const updatedData = [...(prevData || [])];
//                 updatedData[index] = newData;
//                 return updatedData;
//               });
//               localStorage.setItem(name, JSON.stringify(newData)); // Cache fresh data
//             }
//             setIsLoading(false);
//           });

//           unsubscribeFunctions.push(unsubscribe);
//         });
//       }
//     };

//     fetchData(); // Fetch data only once

//     return () => {
//       unsubscribeFunctions.forEach((unsub) => unsub()); // Cleanup listeners
//     };
//   }, [collectionName, collectionNames]);

//   return (
//     <CollectionContext.Provider value={{ data, isLoading }}>
//       {children}
//     </CollectionContext.Provider>
//   );
// };

// // Custom hook for easy access
// export const useCollection = () => {
//   return useContext(CollectionContext);
// };